<template>
  <div class="col-12 row q-col-gutter-x-sm items-center">
    <model-form-select
      :field="`conditionsRequirements.${longevityTermField}`"
      class="col-12"
      label="Longevity Term"
      value-type="String"
      :options="$mh.asOptions(['days', 'months', 'years'])"
      map-options
      emit-value
      :rules="[val => !!val || 'Field is required']"
    />
    <model-form-input
      :field="`conditionsRequirements.${longevityMinimumField}`"
      class="col-6"
      :label="`Minimum ${$_.startCase(conditional.conditionsRequirements[longevityTermField])} ${conditional.membershipType?.name ? 'As ' + conditional.membershipType.name : ''}`"
      type="number"
      value-type="Number"
      step="1"
      min="0"
      :rules="[val => $_.isNumber(val) && val >= 0 || 'Field is required']"
    />
    <model-form-input
      :field="`conditionsRequirements.${longevityMaximumField}`"
      class="col-6"
      :label="`Maximum ${$_.startCase(conditional.conditionsRequirements[longevityTermField])} ${conditional.membershipType?.name ? 'As ' + conditional.membershipType.name : ''}`"
      type="number"
      value-type="Number"
      step="1"
      min="1"
      :rules="[val => val === null || val === '' || val >= conditional.conditionsRequirements[longevityMinimumField] || 'Field must be empty or greater than Longevity Minimum']"
    />
  </div>
</template>

<script>
import { CONDITION_REQUIREMENTS } from 'src/models/membership-type/MembershipPoint'

export default {
  name: 'LongevityConditionForm',
  props: {
    conditional: {
      type: Object,
      required: true
    },
    longevityTermField: {
      type: String,
      default: CONDITION_REQUIREMENTS.LONGEVITY_TERM
    },
    longevityMinimumField: {
      type: String,
      default: CONDITION_REQUIREMENTS.LONGEVITY_MINIMUM
    },
    longevityMaximumField: {
      type: String,
      default: CONDITION_REQUIREMENTS.LONGEVITY_MAXIMUM
    }
  }
}

</script>
